// Human-readable byte formatting for storage usage displays.

const UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

/**
 * Format a byte count as a human-readable string (e.g. 1536 → "1.5 KB").
 * Uses binary (1024) units to match storage caps defined in GB.
 */
export function formatBytes(bytes: number, decimals = 1): string {
  if (!bytes || bytes <= 0) return "0 GB";
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    UNITS.length - 1,
  );
  const value = bytes / Math.pow(1024, i);
  // Drop decimals for B/KB/MB where fractions add noise; keep for GB/TB.
  const d = i >= 3 ? decimals : 0;
  return `${value.toFixed(d)} ${UNITS[i]}`;
}
